import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import notification from '../../components/notification';
import { apiURL } from '../../constants';

export const swizzleApi = createApi({
  reducerPath: 'swizzleApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiURL,
    prepareHeaders: (headers) => {
      headers.set('Authorization', `bearer ${localStorage.getItem('token')}`);
      return headers;
    },
  }),
  tagTypes: ['category', 'products', 'menuitems', 'cart', 'order'],
  endpoints: (builder) => ({

    login: builder.mutation({
      query: (body) => ({
        url: '/user/login',
        method: 'POST',
        body,
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled
          .catch((err) => notification({
            title: 'Invalid credentials!',
            description: err?.data?.message || 'Invalid phone number',
            type: 'error',
          }));
      },
    }),

    verify: builder.mutation({
      query: (body) => ({
        url: '/user/verifyOTP',
        method: 'POST',
        body,
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled
          .catch((err) => notification({
            title: 'Invalid OTP!',
            description: err?.data?.message || 'Please enter correct otp',
            type: 'error',
          }));
      },
    }),

    register: builder.mutation({
      query: (body) => ({
        url: '/user/signup',
        method: 'POST',
        body,
      }),
    }),

    getCategory: builder.query({
      query: () => ({
        url: '/categories',
        method: 'GET',
      }),
      providesTags: ['category'],
    }),

    getProducts: builder.query({
      query: () => ({
        url: '/product',
        method: 'GET',
      }),
      transformResponse: (response) => {
        if (response.data && Array.isArray(response.data)) {
          console.log('in api response', response.data);
          return response.data;
        }
        return [];
      },
      providesTags: ['products'],
    }),

    getMenuItems: builder.query({
      query: () => ({
        url: 'user/getmenuitems',
        method: 'GET',
      }),
      providesTags: ['menuitems'],

    }),

    // cart apis
    createCart: builder.mutation({
      query: (body) => ({
        url: 'cart',
        method: 'POST',
        body,
      }),
      // invalidatesTags: ['cart'],
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled
          .catch((err) => notification({
            title: 'Unable to create Cart!',
            description: err?.data?.message || 'Please try again',
            type: 'error',
          }));
      },
    }),

    reservation: builder.mutation({
      query: (body) => ({
        url: '/reservation',
        method: 'POST',
        body,
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled
          .catch((err) => notification({
            title: 'Unable To Create Reservation!',
            description: err?.data?.message,
            type: 'error',
          }));
      },
    }),

    updateCart: builder.mutation({
      query: ({ body, cartId }) => ({
        url: `cart/${cartId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['cart'],
      transformResponse: (response) => response.status,
    }),

    getCart: builder.query({
      query: (userId) => ({
        url: `cart/${userId}`,
        method: 'GET',
      }),
      providesTags: ['cart'],
    }),

    // order
    createOrder: builder.mutation({
      query: (body) => ({
        url: 'order',
        method: 'POST',
        body,
      }),
      onQueryStarted(body, { queryFulfilled }) {
        queryFulfilled
          .catch((err) => notification({
            title: 'Unable to create Order',
            description: err?.data?.message || 'Please try again',
            type: 'error',
          }));
      },
    }),

    order: builder.query({
      query: () => ({
        url: '/order',
        method: 'GET',
      }),
      providesTags: ['order'],
    }),

    getUserProfile: builder.query({
      query: (userId) => ({
        url: `user?id=${userId}`,
        method: 'GET',
      }),
    }),

    createDineOrder: builder.mutation({
      query: (body) => ({
        url: 'order',
        method: 'POST',
        body,
      }),
    }),

  }),
});

export const {
  useOrderQuery,
  useGetCartQuery,
  useLoginMutation,
  useVerifyMutation,
  useGetProductsQuery,
  useRegisterMutation,
  useGetCategoryQuery,
  useGetMenuItemsQuery,
  useUpdateCartmutation,
  useCreateCartMutation,
  useCreateOrderMutation,
  useGetUserProfileQuery,
  useReservationMutation,
  useLazzyGetCategoryQuery,
} = swizzleApi;
